import Switcher from "common/components/ui/Switcher";
import type { PricingPeriodInfo } from "common/types";

const pricingPeriods = [
  { label: "Monthly", value: { period: 1, period_unit: "month" } },
  { label: "3 months", value: { period: 3, period_unit: "month" } },
  { label: "6 months", value: { period: 6, period_unit: "month" } },
  { label: "Yearly", value: { period: 1, period_unit: "year" } },
];

export default function PricingPeriodInfoSelector({
  value,
  setValue,
}: {
  value: PricingPeriodInfo;
  setValue: (newValue: PricingPeriodInfo) => void;
}) {
  return (
    <Switcher
      className="mb-4 mx-auto"
      size="sm"
      options={pricingPeriods.map(({ label, value }) => ({
        label,
        value: JSON.stringify(value),
      }))}
      onOptionSelect={(newSelection) => {
        setValue(JSON.parse(newSelection));
      }}
      selectedOption={JSON.stringify(value)}
    />
  );
}
